<template>
  <div class="container" id="container">
    <div class="top">
      <div class="lottery-block">
        <div class="lottery-box">
          <div class="lottery-item" v-for="(one, i) in imgList" :key="i" @click="start(i)">
            <img :class="index == one.num ? 'active' : ''" :src="one.url" />
          </div>
        </div>
      </div>
    </div>
    <div class="reward">
      <div>
        <img :src="rewardUlr" />
        <div class="reward-word">{{ rewardWordObj[rewardNum] }}</div>
        <div class="reward-word remind-word">{{ remindObj[rewardNum] }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "business",
  components: {},
  data() {
    return {
      imgList: [
        {
          num: 1,
          prizeRank: 1,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward1.png"
        },
        {
          num: 2,
          prizeRank: 5,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png"
        },
        {
          num: 3,
          prizeRank: 2,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward2.png"
        },
        {
          num: 8,
          prizeRank: 5,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png"
        },
        {
          num: 10,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-lottery.png"
        },
        {
          num: 4,
          prizeRank: 5,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png"
        },
        {
          num: 7,
          prizeRank: 4,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward4.png"
        },

        {
          num: 6,
          prizeRank: 5,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png"
        },
        {
          num: 5,
          prizeRank: 3,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward3.png"
        }
      ],
      rewardWordObj: {
        0: "您还未获得奖品",
        1: "三一485遥控挖掘机模型",
        2: "三一起重机积木套装",
        3: "三一定制金挖斗烟灰缸",
        4: "设备免费评估"
      },
      remindObj: {
        0: "",
        1: "*请联系现场工作人员领取奖品",
        2: "*请联系现场工作人员领取奖品",
        3: "*请联系现场工作人员领取奖品",
        4: "*请等待云联专业评估师与您联系"
      },
      endpointObj: {
        1: 1,
        2: 3,
        3: 5,
        4: 7
      },
      userPhone: "",
      rewardNum: 0,
      rewardUlr: `https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward0.png`,
      canClick: true,
      t: null, //定时器
      circles: 1, //所需圈数
      currentcircles: 1, //记录当前是第几圈
      speed: 1, //转动的速度
      endpoint: 1, //最后停止的位置，即选中了谁
      index: 0 //记录当前循环的次数
    }
  },
  created() {
    document.title = "三一云联"
    let params = this.$route.query
    this.userPhone = params.userPhone
    this.getLotteryHistory()
  },
  mounted() {
    document.getElementById("container").scrollIntoView(true)
  },
  methods: {
    getLotteryHistory() {
      this.$api.getLotteryHistory({ phone: this.userPhone, lotteryActivityId: 1 }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.length == 1 && this.userPhone) {
            this.rewardNum = res.data.data[0].prizeRank || 0
          }
        }
      })
    },
    start(i) {
      if (i != 4) return
      if (this.rewardNum != 0) return
      if (!this.canClick) return
      this.canClick = false
      this.circles = 5
      this.currentcircles = 1 //当前的圈数
      this.speed = 700 //频率
      this.$api.getLottery({ phone: this.userPhone, lotteryActivityId: 1 }).then((res) => {
        if (res.data.code == 0) {
          this.index = 1
          this.endpoint = res.data.data[0].prizeRank //中奖号
          this.t = setInterval(this.highTurn, this.speed) //循环奖品方法
        } else {
          this.canClick = true
        }
      })
    },
    highTurn() {
      if (this.index % 8 == 0) {
        this.currentcircles++ //进入下一圈当前圈数+1
        this.index = 0
      }
      this.index++ //然后循环次数+1，不要把它放到圈数加1的前面去
      //这里用来改变速度，第一圈是每经过一个奖品则速度+80，setInterval的第二个参数是多长时间执行一次，值越小，执行的频率越高
      if (this.currentcircles == 1) {
        window.clearInterval(this.t)
        this.speed -= 80 //第一圈开始加速
        this.t = setInterval(this.highTurn, this.speed)
      } else if (this.currentcircles == this.circles) {
        window.clearInterval(this.t)
        this.speed += 80 //最后一圈开始减速
        this.t = setInterval(this.highTurn, this.speed)
      }
      //如果当前圈数等于要循环的圈数，且当前循环到的奖品编号等于终结点则判定为循环结束，最终会停在终点位置的奖品上
      if (this.circles == this.currentcircles && this.index % 8 == this.endpointObj[this.endpoint]) {
        window.clearInterval(this.t) //清除setInterval
        this.t = null //清除定时器
        setTimeout(() => {
          this.canClick = true
          this.index = 0
          this.rewardNum = this.endpoint
          this.$toast({ message: this.rewardWordObj[this.endpoint], position: "bottom" })
          return
        }, 10)
      }
    }
  },
  watch: {
    rewardNum(val) {
      this.rewardUlr = `https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward${val}.png`
      if (val == 0) {
        this.imgList[4].url = "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-lottery.png"
      } else {
        this.imgList[4].url = "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-lottery-gray.png"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  background-color: rgba(255, 206, 142, 1);
}
.top {
  width: 100%;
  overflow: hidden;
  background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-bg1.png") no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 4.5rem;
}
.lottery-block {
  width: 90%;
  margin: 0 auto;
  background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-block.png");
  background-repeat: no-repeat;
  background-size: contain;
  padding: 0.5rem;
  box-sizing: border-box;
}
.lottery-box {
  width: 100%;
  overflow: hidden;
}
.lottery-item {
  width: 33.3%;
  float: left;
  text-align: center;
  box-sizing: border-box;
  padding: 5px;
}
.lottery-item img {
  width: 100%;
  height: auto;
}
.active {
  box-sizing: border-box;
  border: 3px solid rgba(251, 70, 63, 1);
  border-radius: 10px;
}
.reward {
  width: 100%;
  height: 13rem;
  background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-bg2.png");
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  margin-top: -3px;
}
.reward img {
  margin-top: 1.8rem;
  width: 3rem;
}
.reward .reward-word {
  color: #fff;
  font-size: 0.4rem;
  padding-top: 5px;
}
.reward .remind-word {
  color: rgba(237, 52, 0, 1);
}
</style>
